// src/layout/Header.jsx
import React from "react";

export default function Header({
  isLoggedIn,
  isAdmin,
  adminHealthEnabled,
  adminUsersEnabled,   // ← NEW PROP
  user,
  onLogout,
  onShowAbout,
  onNavigate,
  menuOpen,
  setMenuOpen
}) {
  React.useEffect(() => {
    if (!menuOpen) return;
    const onDocClick = (e) => {
      const menu = document.querySelector(".nav-menu");
      const trigger = document.querySelector("[data-testid='menu-button']");
      if (menu && !menu.contains(e.target) && trigger && !trigger.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [menuOpen, setMenuOpen]);

  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const isStoreAdmin = roles.includes("storeadmin");
  const canAdminUsers = (isAdmin || isStoreAdmin) && !!adminUsersEnabled;

  return (
    <header className="topbar">
      <strong className="brand">Squid Stack</strong>
      <div className="grow-spacer" />

      <div className="actions">
        {isLoggedIn && (
          <div className="menu-wrap">
            <button
              type="button"
              data-testid="menu-button"
              className="btn burger"
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              title="Menu"
            >
              <span className="burger-lines" aria-hidden="true" />
              <span className="sr-only">Menu</span>
            </button>

            {menuOpen && (
              <div className="nav-menu" role="menu" aria-label="Main menu">
                <button
                  className="nav-item"
                  role="menuitem"
                  onClick={() => {
                    onShowAbout();
                    setMenuOpen(false);
                  }}
                >
                  About
                </button>

                {/* Existing: Service health for admins (and feature-gated) */}
                {isAdmin && adminHealthEnabled && (
                  <button
                    className="nav-item"
                    role="menuitem"
                    data-testid="admin-item-health"
                    onClick={() => {
                      onNavigate("admin-health");
                      setMenuOpen(false);
                    }}
                  >
                    Service health
                  </button>
                )}

                {/* NEW: User admin menu item (role + FM flag) */}
                {canAdminUsers && (
                  <button
                    className="nav-item"
                    role="menuitem"
                    data-testid="admin-item-users"
                    onClick={() => {
                      onNavigate("admin-users");
                      setMenuOpen(false);
                    }}
                  >
                    User admin
                  </button>
                )}
              </div>
            )}
          </div>
        )}

        {isLoggedIn && (
          <div className="userbox">
            <span className="hello">
              Hello, {(user?.name || user?.full_name || user?.username || "user")}
              {isAdmin && " (admin)"}
            </span>
            <button className="btn" onClick={onLogout}>Logout</button>
          </div>
        )}
      </div>
    </header>
  );
}